import React, { useMemo, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Grid, Typography, Button, TextField } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { AdminXsMenu } from '../../component/admin/AdminXsMenu'
import { Navbar } from '../../component/shared/Navbar'
import { PageContainer } from '../../component/styled/PageContainer'
import { debounce } from 'lodash'
import Table from './Table'

export const LuckyDrawAdminPage = () => {
  const [searchKey, setSearchKey] = useState('')

  const handleSearch = useMemo(() => debounce((value) => setSearchKey(value), 500), [])

  // Any pending debounced call is canceled on unmount
  useEffect(() => {
    return () => {
      handleSearch.cancel()
    }
  }, [handleSearch])

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Lucky Draw Admin</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} py={5} px={1}>
          <Grid item xs={12} display='flex' justifyContent='space-between' alignItems='center'>
            <Typography variant='h1'>Lucky Draw Admin</Typography>
            <AdminXsMenu />
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <TextField
              label='Search'
              variant='outlined'
              onChange={(e) => handleSearch(e.target.value)}
              placeholder='Draw name'
              fullWidth
            />
            <Button
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              variant='contained'
              color='primary'
              component={Link}
              to='/lucky-draw/create'
              size='large'
            >
              Create
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table searchKey={searchKey} />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
